<template>
  <div class="list-page">
    <div class="detail-banner">
      <div class="container">
        <h1>投资资讯</h1>
        <div class="sub">点击卡片在新窗口打开原文</div>
      </div>
    </div>
    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div class="card-grid" v-if="rows.length">
          <div
            v-for="item in rows"
            :key="item.id"
            class="card"
            @click="openLink(item)"
          >
            <div class="card-cover investment-cover">
              <img v-if="item.cover" :src="item.cover" :alt="item.name" @error="onImgError" />
              <span v-else class="cover-letter">投资</span>
            </div>
            <div class="card-body">
              <div class="card-title">{{ item.name }}</div>
              <div class="card-desc">{{ item.introduction }}</div>
              <div class="card-detail-btn">阅读原文 ›</div>
            </div>
          </div>
        </div>

        <div class="empty-block" v-else-if="!loading">暂无资讯</div>
        <div class="empty-block" v-else>加载中…</div>

        <div class="pager" v-if="totalPages > 1">
          <button class="pg-btn" :disabled="pageNum <= 1" @click="goPage(pageNum - 1)">‹ 上一页</button>
          <button
            v-for="p in pages"
            :key="p"
            class="pg-num"
            :class="{ active: p === pageNum }"
            @click="goPage(p)"
          >{{ p }}</button>
          <button class="pg-btn" :disabled="pageNum >= totalPages" @click="goPage(pageNum + 1)">下一页 ›</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchInvestmentPage } from '../api/home'

export default {
  name: 'InvestmentList',
  data () {
    return {
      rows: [],
      pageNum: 1,
      pageSize: 8,
      total: 0,
      loading: true
    }
  },
  computed: {
    totalPages () {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pages () {
      const tp = this.totalPages
      const cur = this.pageNum
      if (tp <= 7) return Array.from({ length: tp }, (_, i) => i + 1)
      const set = new Set([1, tp, cur, cur - 1, cur + 1, cur - 2, cur + 2])
      const arr = [...set].filter(p => p >= 1 && p <= tp).sort((a, b) => a - b)
      const out = []
      let prev = 0
      for (const p of arr) {
        if (p - prev > 1) out.push('...')
        out.push(p)
        prev = p
      }
      return out
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const res = await fetchInvestmentPage({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.rows = res.rows
        this.total = res.total
      } catch (e) {
        this.rows = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    openLink (item) {
      if (item.link) {
        window.open(item.link, '_blank')
      } else {
        this.$toast.show({ message: '该资讯暂无可访问原文', type: 'error' })
      }
    },
    goPage (p) {
      if (p < 1 || p > this.totalPages || p === this.pageNum) return
      this.pageNum = p
      this.load()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.investment-cover {
  background: linear-gradient(135deg, #38b6a4, #1f7a8c);
  position: relative;
}
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 34px;
  flex-wrap: wrap;
}
.pg-btn,
.pg-num {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text-main);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.pg-btn:hover:not(:disabled),
.pg-num:hover {
  border-color: var(--primary);
  color: var(--primary);
}
.pg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.pg-num.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}
.pager :not(button) {
  color: var(--text-sub);
  padding: 0 4px;
}
.empty-block {
  text-align: center;
  color: var(--text-sub);
  padding: 40px 0;
}
</style>
